import { Outlet, ScrollRestoration } from 'react-router';
import { Footer } from '@/components/layout/Footer';
import { Header } from '@/components/layout/Header';
import { ScrollToTopButton } from '@/components/layout/ScrollToTopButton';

const MainContentId = 'main-content';

export function PageLayout() {
  return (
    <div className="flex min-h-dvh flex-col bg-background text-foreground">
      <a
        href={`#${MainContentId}`}
        className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-graphite focus:px-4 focus:py-2 focus:font-semibold focus:text-paper"
      >
        Skip to main content
      </a>
      <Header />
      <main id={MainContentId} tabIndex={-1} className="flex-1 focus:outline-none">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTopButton />
      <ScrollRestoration />
    </div>
  );
}